module.exports = require("fs");


/*****************
 ** WEBPACK FOOTER
 ** external "fs"
 ** module id = 12
 ** module chunks = 0
 **/